module.exports = "varying vec2 v_Uv;\r\nvoid main() {\r\n    v_Uv = uv;\r\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/js/shader/vertexInfo/vertexShader.glsl
// module id = 23
// module chunks = 0